import get from 'lodash/get'
import indexOf from 'lodash/indexOf'
import {createSelector} from 'reselect'

import * as api from '../../../store/api'
import {
  EventRoles,
  EventTypes,
  GuestOrGroomsmanFunnel,
  OnboardingSteps,
  OwnerFunnel,
  RegisteredGuestOrGroomsmanFunnel,
  RegisteredOwnerFunnel,
  RegisteredSpecialEventFunnel,
  SpecialEventFunnel,
} from '../../../store/enum'
import * as events from '../../../store/events'
import {isFilledString, or} from '../../../utils'

// Get

export const attributionAnswer = (state) => get(state, 'onboarding.attributionAnswer')
export const direction = (state) => get(state, 'onboarding.direction')
export const emailInput = (state) => get(state, 'onboarding.emailInput')
export const onSuccess = (state) => get(state, 'onboarding.onSuccess')
export const step = (state) => get(state, 'onboarding.step')
export const madlibsEditingId = (state) => get(state, 'onboarding.madlibsEditingId')

// Boolean

export const attributionIsProcessing = (state) => !!get(state, 'onboarding.attributionIsProcessing')
export const isOpen = (state) => !!get(state, 'onboarding.isOpen')
export const passwordResetRequestFormIsVisible = (state) =>
  !!get(state, 'onboarding.passwordResetRequestFormIsVisible')
export const passwordResetRequestSuccessIsVisible = (state) =>
  !!get(state, 'onboarding.passwordResetRequestSuccessIsVisible')
export const registeredWhenOpened = (state) => !!get(state, 'onboarding.registeredWhenOpened')

// Computed

export const getFunnel = createSelector(
  events.currentOwnerRole,
  events.currentType,
  registeredWhenOpened,
  (ownerRole, type, wasRegisteredWhenOpened) => {
    const ownerFunnelVariation = OwnerFunnel
    const registeredOwnerFunnelVariation = RegisteredOwnerFunnel

    // Special Event
    if (type !== EventTypes.wedding) {
      return wasRegisteredWhenOpened ? RegisteredSpecialEventFunnel : SpecialEventFunnel
    }

    // Wedding Guest or Groomsman
    if (ownerRole === EventRoles.weddingGuest || ownerRole === EventRoles.groomsman) {
      return wasRegisteredWhenOpened ? RegisteredGuestOrGroomsmanFunnel : GuestOrGroomsmanFunnel
    }

    // Bride/Groom
    if (ownerRole === EventRoles.bride || ownerRole === EventRoles.groom) {
      if (wasRegisteredWhenOpened) {
        return registeredOwnerFunnelVariation
      }

      return ownerFunnelVariation
    }

    return wasRegisteredWhenOpened ? registeredOwnerFunnelVariation : ownerFunnelVariation
  },
)

export const getNextStep = createSelector(getFunnel, step, (x, y) => x[indexOf(x, y) + 1])

export const getPrevStep = createSelector(getFunnel, step, (x, y) => x[indexOf(x, y) - 1])

export const currentStepIsEventSummary = createSelector(
  step,
  (s) => s === OnboardingSteps.eventSummary,
)

export const currentStepIsLogin = createSelector(step, (s) => s === OnboardingSteps.login)

const currentStepIndex = createSelector(getFunnel, step, indexOf)

const registrationStepIndex = createSelector(getFunnel, (x) =>
  indexOf(x, OnboardingSteps.registration),
)

const currentStepIsNotInFunnel = createSelector(currentStepIndex, (i) => i === -1)

const currentStepIsInitialStep = createSelector(currentStepIndex, (i) => i === 0)

const currentStepIsRegistration = createSelector(
  currentStepIndex,
  registrationStepIndex,
  (curr, reg) => curr === reg,
)

export const currentStepIsLastStep = createSelector(
  currentStepIndex,
  getFunnel,
  (curr, funnel) => curr === funnel.length - 1,
)

export const progressDividend = createSelector(currentStepIndex, (i) => i + 1)

export const progressDivisor = createSelector(registrationStepIndex, (i) => i + 1)

const currentStepIsAfterRegistration = createSelector(
  currentStepIndex,
  registrationStepIndex,
  (curr, reg) => curr > reg,
)
export const hideBackButton = createSelector(
  currentStepIsNotInFunnel,
  currentStepIsInitialStep,
  currentStepIsAfterRegistration,
  api.participant.isSuccess,
  or,
)

export const hideProgress = createSelector(
  currentStepIsInitialStep,
  currentStepIsNotInFunnel,
  currentStepIsRegistration,
  currentStepIsAfterRegistration,
  or,
)

// are we editing a specific part of madlibs (event) data, e.g. event type
export const madlibsIsEditingId = (state, id) => !!(id && madlibsEditingId(state) === id)

// is a madlibs dropdown or modal open, essentially
export const madlibsIsEditing = createSelector(madlibsEditingId, isFilledString)
